const $inject = [];

const searchResultsLoaderService = () => {
  return {
    isActive: false
  };
};

searchResultsLoaderService.$inject = $inject;

export default searchResultsLoaderService;



// WEBPACK FOOTER //
// ./src/components/lbSearchResultsLoader/searchResultsLoaderService.js